(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/jotai/atoms.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/jotai/atoms.js');
"use strict";

var _svs$lyckoplatsen$dat, _svs$lyckoplatsen$dat2, _svs$lyckoplatsen$dat3, _svs$lyckoplatsen$dat4, _svs$lyckoplatsen$dat5, _initialSpanResults$r;

const _jotai = jotai,
  atom = _jotai.atom;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_constants,
  CORRECTION_STEP = _svs$lyckoplatsen$com.CONSTANTS.CORRECTION_STEP,
  productMapping = _svs$lyckoplatsen$com.productMapping;
const initialResultData = (_svs$lyckoplatsen$dat = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.result;
const initialResult = Array.isArray(initialResultData) ? initialResultData[0] : initialResultData;
const initialSpanResults = (_svs$lyckoplatsen$dat2 = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat2 === void 0 ? void 0 : _svs$lyckoplatsen$dat2.spanResults;
const resultLatest = (_svs$lyckoplatsen$dat3 = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat3 === void 0 ? void 0 : _svs$lyckoplatsen$dat3.result_latest;
const currentWager = (_svs$lyckoplatsen$dat4 = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat4 === void 0 || (_svs$lyckoplatsen$dat4 = _svs$lyckoplatsen$dat4.mybets_wagers) === null || _svs$lyckoplatsen$dat4 === void 0 || (_svs$lyckoplatsen$dat4 = _svs$lyckoplatsen$dat4.wagers) === null || _svs$lyckoplatsen$dat4 === void 0 ? void 0 : _svs$lyckoplatsen$dat4[0];
const showFullscreen = (_svs$lyckoplatsen$dat5 = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat5 === void 0 ? void 0 : _svs$lyckoplatsen$dat5.showFullscreen;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
let correctionStep;
let isLatestResult = false;
let START_STEP = CORRECTION_STEP.RESULT;
if (initialResult) {
  START_STEP = productMapping.isLyckoplatsenPrimary(initialResult.productId) ? CORRECTION_STEP.TOPWIN : CORRECTION_STEP.PLACE;
}
if (currentWager) {
  var _svs$lyckoplatsen$dat6;
  const isExamined = currentWager.examinedDraws.some(d => initialResult && d.drawNumber === initialResult.drawNumber && productMapping.getProductNumericId(d.productId) === initialResult.productId);
  const hasAccessToken = Boolean((_svs$lyckoplatsen$dat6 = svs.lyckoplatsen.data.shared_result) === null || _svs$lyckoplatsen$dat6 === void 0 ? void 0 : _svs$lyckoplatsen$dat6.params.accessToken);
  const shouldUncorrect = Boolean(svs.utils.paramHandler.get({
    key: 'uncorrect'
  }).value);
  correctionStep = isExamined && !hasAccessToken || shouldUncorrect ? CORRECTION_STEP.RESULT : START_STEP;
} else if (initialResult) {
  correctionStep = isSelfService || (resultLatest === null || resultLatest === void 0 ? void 0 : resultLatest.drawNumber) !== (initialResult === null || initialResult === void 0 ? void 0 : initialResult.drawNumber) ? CORRECTION_STEP.RESULT : START_STEP;
}
if (resultLatest && initialResult) {
  isLatestResult = !isSelfService && resultLatest.drawNumber === initialResult.drawNumber;
}
if (showFullscreen) {
  correctionStep = productMapping.isLyckoplatsenPrimary(initialResult.productId) ? CORRECTION_STEP.TOPWIN : CORRECTION_STEP.PLACE;
}
const initialState = {
  correctionStepAtom: correctionStep,
  correctionTriggerTypeAtom: null,
  selectedResultAtom: initialResult !== null && initialResult !== void 0 ? initialResult : null,
  selectedSpanResultsAtom: initialSpanResults !== null && initialSpanResults !== void 0 ? initialSpanResults : {
    results: []
  },
  selectedHighlightedWinGroup: null,
  overlayResultAtom: null,
  shouldShowIntervalAtom: (initialSpanResults === null || initialSpanResults === void 0 || (_initialSpanResults$r = initialSpanResults.results) === null || _initialSpanResults$r === void 0 ? void 0 : _initialSpanResults$r.length) > 0,
  playCorrectionTlAtom: false,
  autoPlayLatestCorrectionTlAtom: false,
  showFullscreenAtom: showFullscreen,
  isLatestResultAtom: isLatestResult,
  showHomeLocationPinAtom: false
};
const atoms = {
  shouldShowIntervalAtom: atom(initialState.shouldShowIntervalAtom),
  selectedResultAtom: atom(initialState.selectedResultAtom),
  selectedSpanResultsAtom: atom(initialState.selectedSpanResultsAtom),
  overlayResultAtom: atom(initialState.overlayResultAtom),
  selectedHighlightedWinGroupAtom: atom(initialState.selectedHighlightedWinGroup),
  correctionStepAtom: atom(initialState.correctionStepAtom),
  correctionTriggerTypeAtom: atom(initialState.correctionTriggerTypeAtom),
  playCorrectionTlAtom: atom(initialState.playCorrectionTlAtom),
  autoPlayLatestCorrectionTlAtom: atom(initialState.autoPlayLatestCorrectionTlAtom),
  showFullscreenAtom: atom(initialState.showFullscreenAtom),
  isLatestResultAtom: atom(initialState.isLatestResultAtom),
  showHomeLocationPinAtom: atom(initialState.showHomeLocationPinAtom),
  distributionArrayAtom: atom([])
};
setGlobal('svs.lyckoplatsen.components.shared_result.jotai', {
  atoms
});

 })(window);